<script>
import { Line } from 'vue-chartjs';
import * as chartFormatting from '@/utilities/chart-formatting.js';
import debounce from 'lodash/debounce';

const data = [
  [
    0,
    0,
    0,
    1500000,
    3000000,
    6000000,
    8500000,
    10000000,
    13000000,
    14500000,
    16500000,
    18500000,
    30000000,
    37500000,
    45000000,
    52500000,
    70000000,
    87500000,
    105000000,
    125000000,
    145000000,
    166000000,
    187000000,
    208000000,
    229000000,
    244000000,
    251500000,
    251500000,
    251500000,
    251500000,
    251500000,
    251500000,
    255400000,
    259900000,
    279900000,
    300000000,
    318000000,
    328000000,
    335500000,
    342500000,
    349500000,
    356500000,
    363500000,
    370500000,
    377500000,
    384500000,
    392000000,
    400500000,
    409500000,
  ]
];
const chartSpec = {
  labels: chartFormatting.determineXLabels(),
  datasets: [
    {
      borderWidth: 1,
      data: data[0],
      lineTension: 0.4,
      pointRadius: 0,
      pointHoverRadius: 0
    }
  ]
};
const chartOptions = {
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    }
  },
  animation: {
    easing: chartFormatting.animationEasing,
    duration: chartFormatting.animationDuration
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 20,
          autoSkip: true,
          beginAtZero: false,
          fontColor: '#424242',
          fontFamily: chartFormatting.labelFontFamily,
          fontSize: 14,
          lineHeight: 2,
          maxTicksLimit: 10,
          callback: function (val) { // Format the dollars on the Y-axis
            if (val >= 1000000000) { // $x.xB
              return '$' + (val / 1000000000) + 'B';
            } else if (val >= 1000000) { // $x.xM
              return '$' + (val / 1000000) + 'M';
            } else { // $xx,xxx
              return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        },
        gridLines: {
          drawTicks: false,
          display: false
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          zeroLineColor: 'transparent'
        },
        ticks: chartFormatting.xLabelFormat
      }
    ]
  }
};

export default {
  name: 'CumulativeDividendsChart',
  extends: Line,
  data: function () {
    return {
      chartSpec: chartSpec,
      chartOptions: chartOptions
    };
  },
  mounted () {
    this.resize();
    document.addEventListener('aos:in:cumulative-dividends-chart', this.aosChartEvent);
    this.handleDebouncedResize = debounce(this.resize, 50);
    window.addEventListener('resize', this.handleDebouncedResize);
  },
  beforeDestroy () {
    document.removeEventListener('aos:in:cumulative-dividends-chart', this.aosChartEvent);
    window.removeEventListener('resize', this.handleDebouncedResize);
  },
  methods: {
    aosChartEvent: function (event) {
      document.removeEventListener('aos:in:cumulative-dividends-chart', this.aosChartEvent);
      this.render();
    },
    render: function () {
      const ctx = this.$refs.canvas.getContext('2d');
      const container = $(this.$refs.canvas).parents('.chart-container');
      var gradientFill = (
        ctx.createLinearGradient(
          0,
          container.height() / 2,
          container.width(),
          container.height() / 2
        )
      );
      gradientFill.addColorStop(0, '#7AC9D5');
      gradientFill.addColorStop(1, '#1E4B66');
      this.chartSpec.datasets[0].backgroundColor = gradientFill;
      this.renderChart(this.chartSpec, this.chartOptions);
    },
    resize: function () {
      this.chartSpec.labels = chartFormatting.determineXLabels();
      this.render();
    }
  }
};
</script>
